import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import AdminPortalLayout from "./AdminPortalLayout";
import { fetchData } from "../../../helper/ApiCall";
import { END_POINT, METHODS } from "../../../helper/helper";

const AdminDocumentsPage = () => {
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [typeFilter, setTypeFilter] = useState("all");
  const [accessFilter, setAccessFilter] = useState("all");

  const loadDocuments = async () => {
    setLoading(true);
    try {
      const result = await fetchData(END_POINT.GetAdminDocument, METHODS.GET);
      if (result?.success) {
        setDocuments(result.data || []);
      } else {
        setDocuments([]);
      }
    } catch (error) {
      setDocuments([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDocuments();
  }, []);

  const filteredDocuments = useMemo(() => {
    return documents.filter((item) => {
      const query = searchText.trim().toLowerCase();
      const type = String(item.type || "").toLowerCase();
      const access = String(item.accessLevel || "").toLowerCase();
      const docId = String(item.document_id || "").toLowerCase();
      const notice = String(item.noticeId || "").toLowerCase();

      if (typeFilter !== "all" && type !== typeFilter) return false;
      if (accessFilter !== "all" && access !== accessFilter) return false;
      if (!query) return true;
      return docId.includes(query) || notice.includes(query) || type.includes(query);
    });
  }, [documents, searchText, typeFilter, accessFilter]);

  return (
    <AdminPortalLayout activeKey="documents" title="Documents Display" subtitle="Display authority letters, signed notices, invoices, and receipts." actions={<><Link className="btn btn-light" to="/admin-documents-create">Create Document</Link><Link className="btn btn-light" to="/admin-dashboard">Dashboard</Link></>}>
      <article className="table-panel"><div className="search-row"><input type="text" placeholder="Search by doc id, notice id, type" value={searchText} onChange={(e) => setSearchText(e.target.value)} /><select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}><option value="all">All Types</option><option value="authority letter">Authority Letter</option><option value="signed notice">Signed Notice</option><option value="invoice">Invoice</option><option value="receipt">Receipt</option></select><select value={accessFilter} onChange={(e) => setAccessFilter(e.target.value)}><option value="all">All Access</option><option value="restricted">Restricted</option><option value="client + advocate">Client + Advocate</option><option value="admin only">Admin Only</option></select></div><div className="table-scroll"><table className="crud-table"><thead><tr><th>Doc ID</th><th>Notice ID</th><th>Type</th><th>Uploaded By</th><th>Access</th><th>Status</th><th>Edit</th></tr></thead><tbody>{loading ? <tr><td colSpan="7">Loading documents...</td></tr> : null}{!loading && filteredDocuments.length === 0 ? <tr><td colSpan="7">No documents found</td></tr> : null}{!loading && filteredDocuments.map((item) => (<tr key={item._id}><td>{item.document_id || "-"}</td><td>{item.noticeId || "-"}</td><td>{item.type || "-"}</td><td>{item.uploadedBy || "-"}</td><td>{item.accessLevel || "-"}</td><td>{item.status || "-"}</td><td><Link className="tiny-btn" to={`/admin-documents-create?edit=${item._id}`}>&#9998;</Link></td></tr>))}</tbody></table></div></article>
      <div className="pagination-wrap"><p className="pagination-meta">Showing {filteredDocuments.length} of {documents.length}</p><div className="pagination"><span className="page-btn active">1</span></div></div>
    </AdminPortalLayout>
  );
};

export default AdminDocumentsPage;
